import { isBrowser } from "@chatfood/core-utils";
import { ref, onMounted, onUnmounted, computed } from "vue";

// @TODO move to the design system
export const useWindowResize = () => {
  const width = ref(0);
  const height = ref(0);

  const handler = () => {
    if (!isBrowser()) return;

    width.value = window.innerWidth;
    height.value = window.innerHeight;
  };

  const isMobile = computed(() => width.value <= 576);
  const isTablet = computed(() => width.value <= 991);

  onMounted(() => {
    window.addEventListener("resize", handler);
    handler();
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handler);
  });

  return { width, height, isMobile, isTablet };
};
